import { Trans } from '@lingui/react/macro';

import Message from '@/design_system/Message';
import Stack from '@/design_system/Stack';
import { useArticleContext } from '@/routes/Requests/contexts/ArticleContext';

import { ManualExchangeDueDays } from './ServiceExchange/ExchangeDueDays';
import { ExchangeType, ExchangeTypeInput } from './ServiceExchange/ExchangeType';
import { ReplacementProduct, ReplacementProductInput } from './ServiceExchange/ReplacementProduct';
import { ReplacementUniqueArticle } from './ServiceExchange/ReplacementUniqueArticle';
import { StockLocation, StockLocationInput } from './ServiceExchange/StockLocation';

export const ServiceExchange = () => {
  const { view } = useArticleContext();

  return (
    <Stack gap="1rem">
      {view.services.exchange.exchangeType.editable && <ExchangeTypeInput />}

      <Stack gap="0.5rem">
        {!view.services.exchange.exchangeType.editable && (
          <div>
            <ExchangeType />
            <StockLocation />
            <ManualExchangeDueDays />
          </div>
        )}

        {view.services.exchange.replacementProduct.editable && <ReplacementProductInput />}

        <ReplacementProduct />

        <ReplacementProductMissingPriceError />
      </Stack>

      {view.services.exchange.stockLocation.editable && <StockLocationInput />}

      {view.services.exchange.replacementUniqueArticle.shown &&
        view.services.exchange.replacementUniqueArticle.editable && <ReplacementUniqueArticle />}
    </Stack>
  );
};

const ReplacementProductMissingPriceError = () => {
  const { errors } = useArticleContext();

  if (
    errors.services?.exchange?.workshopPriceUpdateInProgress ||
    errors.services?.exchange?.organizationPriceUpdateInProgress
  ) {
    return (
      <Message type="error">
        <Trans id="service-exchange.errors.price-update-in-progress">
          Please save or cancel the price updates
        </Trans>
      </Message>
    );
  }

  if (
    errors.services?.exchange?.missingWorkshopPrice &&
    errors.services?.exchange?.missingOrganizationPrice
  ) {
    return (
      <Message type="error">
        <Trans id="service-exchange.errors.missing-prices">Please set the missing prices</Trans>
      </Message>
    );
  }

  if (
    errors.services?.exchange?.missingWorkshopPrice ||
    errors.services?.exchange?.missingOrganizationPrice
  ) {
    return (
      <Message type="error">
        <Trans id="service-exchange.errors.missing-price">Please set the missing price</Trans>
      </Message>
    );
  }

  return null;
};
